/* eslint-disable no-undef */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import KeyboardEventHandler from 'react-keyboard-event-handler';

class KeyHandler extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
    this.buffer = [];

    this.onKeyEvent = this.onKeyEvent.bind(this);
    this.handleKeyboardEvent = this.handleKeyboardEvent.bind(this);
    window.onDidDetectWord = this.props.onDidDetectWord;
  }


  componentDidMount() {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', this.handleKeyboardEvent, false);
    }
  }

  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('keydown', this.handleKeyboardEvent, false);
    }
  }

  handleKeyboardEvent(event) {
    const charCode = event.keyCode || event.which;
    let charStr = String.fromCharCode(charCode);

    if (!event.shiftKey) {
      charStr = charStr.toLowerCase();
    }

    if (event.keyCode == 12) {
      this.buffer = [];
      return;
    }

    if (event.keyCode == 13) {
      let output = this.buffer.join('');
      console.log(output)
      this.buffer = [];


      if (output.includes('+') && !output.startsWith('_R')) {
        output = output.substring(output.indexOf('+') + 1);
      }

      if (output.endsWith('(')) {
        output = output.slice(0, -1);
      }

      this.props.onDidDetectWord(output);
      return;
    }

    if (event.keyCode == 16) {
      this.shift = true;
      return;
    }

    if (event.keyCode == 189) {
      charStr = event.shiftKey ? '_' : '-';
    }

    if (event.keyCode == 186) {
      charStr = ':';
    }

    if (event.keyCode == 188) {
      charStr = event.shiftKey ? ';' : ',';
    }

    if (event.keyCode == 48) {
      charStr = event.shiftKey ? '=' : '0';
    }

    if (event.keyCode == 55) {
      charStr = event.shiftKey ? '/' : '7';
    }

    if (event.keyCode == 187) {
      charStr = '+';
    }

    if (event.keyCode == 190) {
      charStr = event.shiftKey ? ':' : charStr;
    }

    if (event.keyCode == 220 || event.keyCode == 191) {
      charStr = '#';
    }

    if (charStr === 'ß' || charStr === '[') { // tolerate misconfigured scanners
      charStr = '-';
    }

    this.buffer.push(charStr);
    console.log(new Date().getTime(), event.keyCode, event.which, charStr, event.shiftKey);

  }

  onKeyEvent(key, event) {
    if (key === 'clear') {
      this.buffer = [];
    } else if (key == 'shift') {
      this.shift = true;
    } else if (key !== 'enter') {
      this.buffer.push(this.shift ? key.toUpperCase() : key);
      this.shift = false;
    } else {
      const output = this.buffer.join('');
      this.buffer = [];
      this.props.onDidDetectWord(output);
    }
  }

  render() {
    return <span />;
  }
}

KeyHandler.propTypes = {
  onDidDetectWord: PropTypes.func.isRequired,
};

export default KeyHandler;
